import React, { useEffect } from 'react';
import { Field, Form } from 'react-final-form';
import { Button, ButtonToolbar } from 'reactstrap';
import CustomFileInput from '../../../components/form/CustomFileInput';
import CustomInputField from '../../../components/form/CustomInputField';
import CustomSelect from '../../../components/form/CustomSelect';
import { useDict } from '../../../contexts/LanguageContext';

const BankAccountForm = (props) => {
    const {
        onSubmit,
        banks,
        bankAccountTypes,
        countries,
        bankAcc,
    } = props;

    const dict = useDict();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const validateStepAccBank = (values) => {
        const errors = {};

        if (!values.account_no) {
            errors.account_no = dict.accountNumberEmpty;
        } else if (!/^[0-9]*$/i.test(values.account_no)) {
            errors.account_no =
                dict.accountNumberInvalid;
        }

        if (!values.account_name) {
            errors.account_name = dict.accountNameEmpty;
        }

        if (!values.bank_id) {
            errors.bank_id = dict.bankSelectEmpty;
        }

        if (!values.account_type_id) {
            errors.account_type_id = dict.accountTypeSelectEmpty;
        }

        if (!values.country_id) {
            errors.country_id = dict.countryEmpty;
        }

        if (values.statement && values.statement.size > 10 * 1024 * 1024) {
            errors.statement = dict.fileTooLarge
        }

        return errors;
    };

    return (
        <Form
            initialValues={{
                submitted: bankAcc?.submitted || '',
                bank_id: bankAcc?.bank_id || '',
                account_no: bankAcc?.account_no || '',
                account_name: bankAcc?.account_owner_name || '',
                account_type_id: bankAcc?.bank_account_type_id || '',
                branch: bankAcc?.branch || '',
                address_bank: bankAcc?.address || '',
                swift_code: bankAcc?.swift_code || '',
                country_id: bankAcc?.country_id || 1,
            }}
            validate={validateStepAccBank}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, values }) => (
                <form className="form  wizard__form_2" onSubmit={handleSubmit}>
                    <div
                        className="form__form-group"
                        style={{ borderBottom: 'dashed 1px #DDDDDD' }}
                    >
                        <div
                            className="card__title"
                            style={{ marginBottom: '5px' }}
                        >
                            <h4
                                className="bold-text"
                                style={{ fontSize: '14px' }}
                            >
                                {dict.bankAccountTitle}
                            </h4>
                            <h5 className="subhead">
                                {dict.bankAccountSubtitle}
                            </h5>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <div className="form__form-group-input-wrap">
                                <Field name="bank_id">
                                    {({ input, meta }) => (
                                        <CustomSelect
                                            input={input}
                                            meta={meta}
                                            submitted={values.submitted}
                                            placeholder={dict.selectBank + " *"}
                                            options={banks}
                                            data-cy="bankAccount__bankId"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field" data-private>
                            <Field name="account_no">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        submitted={values.submitted}
                                        placeholder={dict.accountNumber + " *"}
                                        type="text"
                                        style={{}}
                                        data-cy="bankAccount__accountNumber"
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field" data-private>
                            <Field name="account_name">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        submitted={values.submitted}
                                        placeholder={dict.accountName + " *"}
                                        type="text"
                                        style={{}}
                                        data-cy="bankAccount__accountName"
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <div className="form__form-group-input-wrap">
                                <Field name="account_type_id">
                                    {({ input, meta }) => (
                                        <CustomSelect
                                            input={input}
                                            meta={meta}
                                            submitted={values.submitted}
                                            placeholder={dict.accountType + " *"}
                                            options={bankAccountTypes}
                                            data-cy="bankAccount__accountType"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <Field name="branch">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        submitted={values.submitted}
                                        placeholder={dict.branchOptional}
                                        type="text"
                                        style={{}}
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <Field name="address_bank">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        submitted={values.submitted}
                                        placeholder={dict.addressOptional}
                                        type="text"
                                        style={{}}
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field" data-private>
                            <Field name="swift_code">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        submitted={values.submitted}
                                        placeholder={dict.swiftOptional}
                                        type="text"
                                        style={{}}
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <div className="form__form-group-input-wrap">
                                <Field name="country_id">
                                    {({ input, meta }) => (
                                        <CustomSelect
                                            input={input}
                                            meta={meta}
                                            submitted={values.submitted}
                                            placeholder={dict.country + " *"}
                                            options={countries}
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                    <div
                        className="form__form-group"
                        style={{ borderBottom: 'dashed 1px #DDDDDD' }}
                    >
                        <div
                            className="card__title"
                            style={{ marginBottom: '5px' }}
                        >
                            <h4
                                className="bold-text"
                                style={{ fontSize: '14px' }}
                            >
                                {dict.uploadBankStatementOptional}
                            </h4>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">
                            {dict.bankStatementText}
                        </span>
                        <div className="form__form-group-field">
                            <div
                                className="form__form-group-input-wrap"
                                style={{ marginTop: '5%' }}
                                data-private
                            >
                                <Field name="statement" type="file">
                                    {({ input, meta }) => (
                                        <CustomFileInput
                                            input={input}
                                            meta={meta}
                                            outputBase64
                                            data-cy="bankAccount__statement"
                                            accept="application/pdf, image/jpeg, image/png"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                        <Button
                            type="submit"
                            className="next btn btn-outline-primary btn_uni rounded"
                            data-cy="bankAccount__nextBtn"
                        >
                            {dict.next}
                        </Button>
                    </ButtonToolbar>
                </form>
            )}
        </Form>
    );
};

export default BankAccountForm;
